import { typography } from "../typography/typography.js";
import "../typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../typography/utils/typographyVariants/typographyVariants.js";
const MuiPickersCalendarHeader = {
  styleOverrides: {
    label: ({ theme }) => ({
      ...typography["Lato Emphasized 2"],
      color: theme.palette.grey["800"]
    }),
    switchViewButton: ({ theme }) => ({
      color: theme.palette.primary["700"]
    })
  }
};
export {
  MuiPickersCalendarHeader
};
